"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function GoogleContacts24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M9.53897 11.6924C5.2867 11.6924 1.84668 15.1324 1.84668 19.3847V22.6155C1.84668 23.38 2.4667 24.0001 3.23129 24.0001H6.92359L10.6159 11.6924H9.53897Z", fill: "#86A9FF" }),
        react_1.default.createElement("path", { d: "M22.154 16.7693C22.154 13.9631 19.8832 11.6924 17.0771 11.6924H13.3848V24.0001H17.0771C19.8832 24.0001 22.154 21.7293 22.154 18.9232", fill: "#578CFF" }),
        react_1.default.createElement("path", { d: "M5.53906 16.7693C5.53906 13.9631 7.80985 11.6924 10.616 11.6924H13.3852C16.1914 11.6924 18.4621 13.9632 18.4621 16.7693V18.9232C18.4621 21.7293 16.1913 24.0001 13.3852 24.0001H6.92367C6.15908 24.0001 5.53906 23.38 5.53906 22.6155V16.7693Z", fill: "#0057CC" }),
        react_1.default.createElement("path", { d: "M11.9997 9.53846C14.6337 9.53846 16.7689 7.40321 16.7689 4.76923C16.7689 2.13526 14.6337 0 11.9997 0C9.36573 0 7.23047 2.13526 7.23047 4.76923C7.23047 7.40321 9.36573 9.53846 11.9997 9.53846Z", fill: "#0057CC" }));
}
function GoogleContacts24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(GoogleContacts24Svg, Object.assign({}, svgProps)));
}
exports.default = GoogleContacts24;
//# sourceMappingURL=GoogleContacts24.js.map